import React from 'react';

/**
 * Piezas de interfaz del módulo Tareas. Los modales usan los de A medias
 * (ModalBase, Campo, MensajeError…); aquí solo cambia el acento: lumbre, el
 * color cálido del logo, el del fuego del hogar.
 */
export { ModalBase, Campo, MensajeError, aInput, deInput } from '../amedias/ui';

export const claseInput =
  'w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 ' +
  'text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-lumbre-500 focus:border-transparent';

export const botonPrincipal =
  'inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-lg ' +
  'bg-lumbre-600 hover:bg-lumbre-700 text-white transition disabled:opacity-60';

export const botonSecundario =
  'inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-lg border ' +
  'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition';

export const botonIcono =
  'p-2 rounded-lg text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition disabled:opacity-40';

/** Botón de selección tipo «pastilla». */
export const chip = (activo: boolean) =>
  `px-3 py-1.5 text-xs font-semibold rounded-lg border transition ${
    activo
      ? 'bg-lumbre-600 border-lumbre-600 text-white'
      : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-gray-400'
  }`;

export const BotonesModal: React.FC<{ guardando: boolean; texto: string; onClose: () => void }> =
  ({ guardando, texto, onClose }) => (
    <div className="flex gap-2 pt-2">
      <button type="submit" disabled={guardando} className={`flex-1 py-2.5 ${botonPrincipal}`}>
        {guardando ? 'Guardando…' : texto}
      </button>
      <button type="button" onClick={onClose} className={`px-5 py-2.5 ${botonSecundario}`}>Cancelar</button>
    </div>
  );

export const ICONOS_CASA = ['🏠', '🏡', '🏢', '🏖️', '🏔️', '👵', '👨‍👩‍👧', '🐶', '🌿', '🙋'];

export const ICONOS_TAREA = [
  '🧹', '🧽', '🍽️', '🗑️', '♻️', '🧺', '👕', '🛏️', '🚿', '🚽', '🪟', '🧼',
  '🛒', '🍳', '🌱', '🐶', '🐱', '🚗', '🔧', '💡', '📦', '🧴', '🪴', '📬',
];
